export default __webpack_public_path__ + "static/media/cashflow.bdd482c1.svg";